"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortByBooleanField = exports.sortByTimestampField = exports.sortByNumericalField = exports.sortByField = exports.alphanumericSort = void 0;

var _SortDirections = _interopRequireDefault(require("../constants/SortDirections"));

var reA = /[^a-zA-Z]/g;
var reN = /[^0-9]/g;

var alphanumericSort = function alphanumericSort(a, b) {
  var aA = a.replace(reA, '');
  var bA = b.replace(reA, '');

  if (aA === bA) {
    var aN = parseInt(a.replace(reN, ''), 10);
    var bN = parseInt(b.replace(reN, ''), 10);

    if (aN === bN) {
      return 0;
    } else if (aN > bN) {
      return 1;
    }

    return -1;
  }

  return aA > bA ? 1 : -1;
};

exports.alphanumericSort = alphanumericSort;

var sortByField = function sortByField(field) {
  var sortDir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _SortDirections.default.ASCENDING;
  return function (a, b) {
    return alphanumericSort(a.get(field), b.get(field)) * sortDir;
  };
};

exports.sortByField = sortByField;

var sortByNumericalField = function sortByNumericalField(field) {
  var sortDir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _SortDirections.default.ASCENDING;
  return function (a, b) {
    if (isNaN(a.get(field)) && !isNaN(b.get(field))) {
      return -1 * sortDir;
    } else if (!isNaN(a.get(field)) && isNaN(b.get(field))) {
      return Number(sortDir);
    } else if (isNaN(a.get(field)) && isNaN(b.get(field))) {
      return 0;
    } else if (a.get(field) < b.get(field)) {
      return -1 * sortDir;
    } else if (a.get(field) > b.get(field)) {
      return Number(sortDir);
    }

    return 0;
  };
};

exports.sortByNumericalField = sortByNumericalField;

var sortByTimestampField = function sortByTimestampField(field) {
  var sortDir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _SortDirections.default.ASCENDING;
  return function (a, b) {
    if (a.get(field) < b.get(field)) {
      return Number(sortDir);
    } else if (a.get(field) > b.get(field)) {
      return -1 * sortDir;
    }

    return 0;
  };
};

exports.sortByTimestampField = sortByTimestampField;

var sortByBooleanField = function sortByBooleanField(field) {
  var sortDir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _SortDirections.default.ASCENDING;
  return function (a, b) {
    if (a.get(field) && !b.get(field)) {
      return Number(sortDir);
    } else if (!a.get(field) && b.get(field)) {
      return -1 * sortDir;
    }

    return 0;
  };
};

exports.sortByBooleanField = sortByBooleanField;